import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("amf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Public
export const getEvents = () => api.get("/events").then((r) => r.data);
export const getPublications = () => api.get("/publications").then((r) => r.data);
export const getBoardMembers = () => api.get("/board-members").then((r) => r.data);
export const getGallery = () => api.get("/gallery").then((r) => r.data);
export const getContent = () =>
  api
    .get("/content", { params: { _t: Date.now() }, headers: { "Cache-Control": "no-cache" } })
    .then((r) => r.data);
export const updateContent = (updates, deletes = []) =>
  api.put("/admin/content", { updates, deletes }).then((r) => r.data);
export const postSubmission = (payload) =>
  api.post("/submissions", payload).then((r) => r.data);

// Auth
export const loginRequest = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const getMe = () => api.get("/auth/me").then((r) => r.data);

// Admin
export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/admin/upload", fd).then((r) => r.data);
};
export const adminGetSubmissions = () =>
  api.get("/admin/submissions").then((r) => r.data);

const crud = (base) => ({
  list: () => api.get(`/${base}`).then((r) => r.data),
  create: (d) => api.post(`/admin/${base}`, d).then((r) => r.data),
  update: (id, d) => api.put(`/admin/${base}/${id}`, d).then((r) => r.data),
  remove: (id) => api.delete(`/admin/${base}/${id}`).then((r) => r.data),
});

export const eventsApi = crud("events");
export const pubsApi = crud("publications");
export const boardApi = crud("board-members");
export const galleryApi = crud("gallery");

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
